import React, {useState} from 'react';
import './contactForm.css';
import {IoLogoWhatsapp} from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import {email, whatsappUrl} from "../../../../components/Constant/socialLinks";
import {FaTelegramPlane} from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import axios from "axios";

const ContactForm = () => {

    const [feedbackMessage, setFeedbackMessage] = useState('');
    const [messageClass, setMessageClass] = useState('');

    const clearFeedbackMessage = () => {
        setTimeout(() => {
            setFeedbackMessage('');
            setMessageClass('');
        }, 3000);  // 3000 milliseconds = 3 seconds
    };

    const sendEmail = async (e) => {
        e.preventDefault();
        const form = e.target;

        const formData = new FormData(form);
        formData.delete('company'); // удаляем honeypot

        const data = Object.fromEntries(formData.entries());

        if (form.company && form.company.value) {
            return;
        }

        setFeedbackMessage('Sending your request...');
        setMessageClass('loading');

        try {
            // Формируем объект для отправки
            const dataForEmail = {
                project: 'offshoreadvisory',
                subject: '/',
                data: data
            };

            const response = await axios.post(
                'https://assembly.tehnik.tech/api/send_form/from',
                dataForEmail,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
            );

            form.reset();
            setFeedbackMessage('Message sent successfully!');
            setMessageClass('success');
            clearFeedbackMessage();
        } catch (err) {
            console.error(err);
            setFeedbackMessage('Failed to send the message, please try again later.');
            setMessageClass('error');
            clearFeedbackMessage();
        }
    };

    return (
        <div className='wrapper'>
            <div className='contact-container container'>
                <div className="contact-form-container">
                    <h2 className='contact-form-title'>Fill the Blank:</h2>
                    <form className='contact-form' onSubmit={sendEmail}>
                        <input
                            className='contact-form-input'
                            type="text"
                            id="name"
                            name="name"
                            placeholder='Full name'
                            required
                        />
                        <input
                            className='contact-form-input'
                            type="email"
                            id="email"
                            name="email"
                            placeholder='example@company.com'
                            required
                        />
                        <textarea
                            className='contact-form-input'
                            id="message"
                            name="message"
                            rows={5}
                            placeholder='Short brief*'
                            required
                        />
                        <button className='contact-button' type="submit">
                            Submit
                        </button>
                    </form>
                    {feedbackMessage && <p className={`feedback-message ${messageClass}`}>{feedbackMessage}</p>}
                </div>

                <div className="contact-info">
                    <div className='contact-info-item'>
                        <h2 className='contact-info-title'>
                            <IoLogoWhatsapp/>
                            &nbsp;
                            <FaTelegramPlane/>
                        </h2>
                        <div className='contact-info-content'>
                            
                            <a href={whatsappUrl} className='contact-info-link' target="_blank">
                                +447385054407
                            </a>
                        </div>
                    </div>

                    <div className='contact-info-item'>
                        <h2 className='contact-info-title'>
                            <IoMdMail/>
                        </h2>
                        <div className='contact-info-content'>

                            <a href={email} className='contact-info-link' target="_blank">
                                info@offshoreadvisory.pro
                            </a>
                        </div>
                    </div>
                    
                    <div className='contact-info-item'>
                        <h2 className='contact-info-title'><FaLocationDot/> Address</h2>
                        <div className='contact-info-content'>
                            <p>
                                25B RICHMOND TERRACE, LIVERPOOL, UNITED KINGDOM, L6 5HU
                            </p>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    );
}

export default ContactForm;
